import React, { Component } from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import logo from '../../../assets/logo.png';
import avalonLogo from '../../../assets/avalon.svg';


class Footer extends Component {
  render() {
    return (
      <footer className="container-fluid">
        <div className="bar"></div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-7 col-lg-5 pr-5">
              <Link to="/" className="logo-wrapper mb-3 d-flex align-items-center">
                <img className="logo" src={logo} alt="Berki Melinda logo" />
                <h4 className="name">Berki Melinda</h4>
              </Link>
              <p className="rights">{`${(new Date()).getFullYear()} - minden jog fenntartva`}</p>
              <p className="rights reg-number">Felnőttképzési nyilvántartási szám:</p>
              <p className="rights">B/2020/000820</p>
              <p className="rights d-flex align-items-center">
                Készítette:
                <a className="avalon" href="http://avalonmedia.hu" target="_blank" rel="noopener noreferrer">
                  <img src={avalonLogo} alt="Avalon Media logo" />
                </a>
              </p>
            </div>
            <div className="col-md-5 col-lg-3 d-flex flex-column">
              <a href="tel:+36703757181" className="contact-item">
                <i className="fas fa-phone"></i>
                <p>+36 70 3757 181</p>
              </a>
              <a href="mailto:info@berkimelinda.hu" className="contact-item">
                <i className="fas fa-envelope"></i>
                <p>info@berkimelinda.hu</p>
              </a>
              <a href="/adatkezeles" className="contact-item">
                <i className="fas fa-info-circle"></i>
                <p>Adatkezelési irányelvek</p>
              </a>
            </div>
          </div>
          <div className="to-up-btn" onClick={() => window.scroll({ top: 0, left: 0, behavior: 'smooth' })}>
            <i className="fas fa-angle-up"></i>
          </div>
        </div>
      </footer>
    );
  }
}


export default Footer;



// WEBPACK FOOTER //
// ./src/components/layout/Footer/Footer.js